import { ComponentHelper } from "../util/componentHelper.js";
import { IsNumericTextBox } from "./isNumericTextBox.js";
import { FieldInstance } from "./field.js";
import { DropDownList } from "./dropDownList.js";
import { Helper } from "../util/helper.js";
import { Button } from "./button.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import { StringKeyDictionary } from "../../commonInterfaces.js";
import React from "react";
export class NodaPeriodeNumericTextBox extends React.Component<NodaPeriodeNumericTextBoxProps, NodaPeriodState>{
    private translations: StringKeyDictionary<string> = null;
    private factory = ComponentHelper.createFactory();
    constructor(props) {
        super(props);
        let period = new NodaPeriod(props.field.defaultComboboxValue);
        period.parse(props.value);
        this.state = { ...period, oldStr: props.value };
        this.initApp();
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.value !== prevState.oldStr) {
            if (nextProps.value === prevState.str)
                return { oldStr: nextProps.str };
            let new_period = new NodaPeriod(nextProps.field.defaultComboboxValue);
            new_period.parse(nextProps.value);
            return { ...new_period, oldStr: nextProps.value };
        }
        else
            return prevState;
    }
    private getNumericTextBoxYearProps = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.field.readOnly = this.props.field.readOnly;
        props.field.decimals = 0;
        props.field.format = "0";
        props.disabled = this.props?.disabled;
        props.value = this.state.years;
        props.onChange = this.onTextBoxChange;
        props.field.model = "Year";
        return props;
    }
    private getNumericTextBoxMonthProps = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.field.readOnly = this.props.field.readOnly;
        props.field.decimals = 0;
        props.field.format = "0";
        props.disabled = this.props?.disabled;
        props.value = this.state.months;
        props.onChange = this.onTextBoxChange;
        props.field.model = "Month";
        return props;
    }
    private getNumericTextBoxWeekProps = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.disabled = this.props?.disabled;
        props.field.readOnly = this.props.field.readOnly;
        props.field.decimals = 0;
        props.field.format = "0";
        props.value = this.state.weeks;
        props.onChange = this.onTextBoxChange;
        props.field.model = "Week";
        return props;
    }
    private getNumericTextBoxDayProps = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.disabled = this.props?.disabled;
        props.field.readOnly = this.props.field.readOnly;
        props.field.decimals = 0;
        props.field.format = "0";
        props.value = this.state.days;
        props.onChange = this.onTextBoxChange;
        props.field.model = "Day";
        return props;
    }

    private getUnitCountProps = () => {
        const props = this.factory.getDefaultNumericTextBoxProps();
        props.disabled = this.props?.disabled;
        props.field.readOnly = this.props.field.readOnly;
        props.field.decimals = 0;
        props.field.format = "0";
        props.field.min = 1;
        props.value = this.state.unitCount;
        props.onChange = this.onTextBoxChange;
        props.field.model = "UnitCount";
        return props;
    }

    private getUnitTypeProps = () => {
        let defaultValue = Helper.hasValue(this.props.field.defaultComboboxValue) ? this.props.field.defaultComboboxValue : 2;
        const props = this.factory.getDefaultDropDownProps();
        props.onDataLoaded = () => { };
        props.disabled = this.props?.disabled;
        props.field.readOnly = false;
        props.value = Helper.hasValue(this.state.unitType) ? this.state.unitType : defaultValue;
        props.onChange = this.onTextBoxChange;
        props.field.dataSourceUrl = "RecurringTask/GetPeriodUnits";
        props.field.dataTextField = "Title";
        props.field.dataValueField = "Value";
        props.field.model = "UnitType";
        props.field.defaultValue = defaultValue;
        return props;
    }

    private onTextBoxChange = (field, value) => {
        let newPeriod = new NodaPeriod(this.props.field.defaultComboboxValue);
        newPeriod.parse(this.state.str);
        newPeriod.viewType = this.state.viewType;
        if (!Helper.hasValue(newPeriod.unitType))
            newPeriod.setUnitType(this.state.unitType);
        switch (field.model) {
            case "Day":
                newPeriod.setDays(value);
                break;
            case "Week":
                newPeriod.setWeeks(value);
                break;
            case "Month":
                newPeriod.setMonths(value);
                break;
            case "Year":
                newPeriod.setYears(value);
                break;
            case "UnitCount":
                newPeriod.setUnitCount(value);
                break;
            case "UnitType":
                newPeriod.setUnitType(value);
                break;
        }
        this.setState({ ...newPeriod, oldStr: this.props.value }, () => this.props.onChange(this.props.field, this.state.str));
    }

    private initApp = () => {
        Helper.getTranslations(["Field.fstasks.Unit.Days", "Field.fstasks.Unit.Month", "Field.fstasks.Unit.Weeks", "Field.fstasks.Unit.Year"])
            .then(result => {
                this.translations = result.Data;
                this.setState({});
            });
    }

    private createInputs = () => {

        const buttonSimple = (this.state.countComponents <= 1) ? (<Button
            iconName="minus"
            handleClick={() => this.setState({ viewType: 1 })}
            text={Helper.getTranslation("Standard.Vereinfacht")}
            buttonStyle={{
                width: "58%",
                height: "30px",
                border: "solid 1px #bdbdbd",
                margin: "1px"
            }}
            readOnly={this.props?.disabled}
        />) : null;
        const additonalButton = (!this.props.field.showSimpleVersion) ? (<Button
            iconName="plus"
            handleClick={() => this.setState({ viewType: 2 })}
            text={Helper.getTranslation("Standard.Erweitert2")}
            buttonStyle={{
                width: "48%",
                height: "30px",
                border: "solid 1px #bdbdbd",
                margin: "1px"
            }}
            readOnly={this.props?.disabled}
        />) : null;
        const input = (this.state.viewType == 1) ? (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: '5px' }}>
                    <div style={{ width: '50%', marginRight: '2%' }}>
                        <IsNumericTextBox  {... this.getUnitCountProps()} />
                    </div>
                    <div style={{ width: '50%' }}>
                        <DropDownList  {... this.getUnitTypeProps()} />
                    </div>
                </div>
                {additonalButton}
            </div>)
            : (
                <div>
                    <FieldInstance label={this.translations["Field.fstasks.Unit.Year"]} noHover={true}>
                        <IsNumericTextBox {... this.getNumericTextBoxYearProps()} />
                    </FieldInstance>
                    <FieldInstance label={this.translations["Field.fstasks.Unit.Month"]} noHover={true}>
                        <IsNumericTextBox {... this.getNumericTextBoxMonthProps()} />
                    </FieldInstance>
                    <FieldInstance label={this.translations["Field.fstasks.Unit.Weeks"]} noHover={true}>
                        <IsNumericTextBox {... this.getNumericTextBoxWeekProps()} />
                    </FieldInstance>
                    <FieldInstance label={this.translations["Field.fstasks.Unit.Days"]} noHover={true}>
                        <IsNumericTextBox {... this.getNumericTextBoxDayProps()} />
                    </FieldInstance>
                    {buttonSimple}
                </div>);
        return input;
    }

    render() {

        return (<>{Helper.hasValue(this.translations) ? this.createInputs() : null}</>);
    }
}
enum PeriodUnits {
    Days = 8,
    Weeks = 4,
    Months = 2,
    Years = 1
}

class NodaPeriod {
    str: string; // gesamter string
    countComponents: number; // wie viele zeitkomponenten im string sind.
    viewType: number; // 1 - edit + typ; 2 - einzelne edits
    days: number;
    weeks: number;
    months: number;
    years: number;
    unitCount?: number;
    unitType?: PeriodUnits;

    constructor(defaultUnitType) {
        this.str = "";
        this.countComponents = 0;
        this.viewType = 1;
        this.days = 0;
        this.weeks = 0;
        this.months = 0;
        this.years = 0;
        this.unitCount = 0;
        this.unitType = defaultUnitType;

    }

    private updateStr() {
        if (this.viewType == 1) {
            this.days = 0;
            this.weeks = 0;
            this.months = 0;
            this.years = 0;
            let desc: string = "";
            if (Helper.hasValue(this.unitCount)) {
                switch (this.unitType) {
                    case PeriodUnits.Days: desc = "D";
                        this.days = this.unitCount;
                        break;
                    case PeriodUnits.Weeks: desc = "W";
                        this.weeks = this.unitCount;
                        break;
                    case PeriodUnits.Months: desc = "M";
                        this.months = this.unitCount;
                        break;
                    case PeriodUnits.Years:
                        this.years = this.unitCount;
                        desc = "Y";
                        break;
                    default:
                        desc = "M";
                        this.months = this.unitCount;
                }
                this.str = "P" + this.unitCount + desc;
            } else {
                this.str = null;
            }

        }
        else {
            // der fall this.view_type == 2
            if (this.countComponents <= 1) {
                // die unit_count und unit_type evtl. aktualisieren.
                if (this.days > 0 || !Helper.hasValue(this.days)) {
                    this.unitCount = this.days;
                    this.unitType = PeriodUnits.Days;
                }
                else if (this.weeks > 0 || !Helper.hasValue(this.weeks)) {
                    this.unitCount = this.weeks;
                    this.unitType = PeriodUnits.Weeks;
                }
                else if (this.months > 0 || !Helper.hasValue(this.months)) {
                    this.unitCount = this.months;
                    this.unitType = PeriodUnits.Months;
                }
                else if (this.years > 0 || !Helper.hasValue(this.years)) {
                    this.unitCount = this.years;
                    this.unitType = PeriodUnits.Years;
                }
            }
            let res: string = "P";
            if (this.years > 0)
                res += this.years.toString() + "Y";
            if (this.months > 0)
                res += this.months.toString() + "M";
            if (this.weeks > 0)
                res += this.weeks.toString() + "W";
            if (this.days > 0)
                res += this.days.toString() + "D";
            this.str = res;
        }
    }

    public setDays(value: number) {
        this.viewType = 2;
        if (this.days === 0 && Helper.hasValue(value) && value !== 0)
            this.countComponents++;
        if (this.days !== 0 && (!Helper.hasValue(value) || value === 0))
            this.countComponents--;
        this.days = value;
        this.updateStr();
    }

    public setWeeks(value: number) {
        this.viewType = 2;
        if (this.weeks === 0 && Helper.hasValue(value) && value !== 0)
            this.countComponents++;
        if (this.weeks !== 0 && (!Helper.hasValue(value) || value === 0))
            this.countComponents--;
        this.weeks = value;
        this.updateStr();
    }

    public setMonths(value: number) {
        this.viewType = 2;
        if (this.months === 0 && Helper.hasValue(value) && value !== 0)
            this.countComponents++;
        if (this.months !== 0 && (!Helper.hasValue(value) || value === 0))
            this.countComponents--;
        this.months = value;
        this.updateStr();
    }

    public setYears(value: number) {
        this.viewType = 2;
        if (this.years === 0 && Helper.hasValue(value) && value !== 0)
            this.countComponents++;
        if (this.years !== 0 && (!Helper.hasValue(value) || value === 0))
            this.countComponents--;
        this.years = value;
        this.updateStr();
    }

    public setUnitCount(value: number) {
        this.unitCount = value;
        this.updateStr();
    }

    public setUnitType(value: PeriodUnits) {
        this.unitType = value;
        this.updateStr();
    }

    public parse(input: string) {
        this.str = input;
        this.countComponents = 0;
        if (Helper.hasValue(input)) {
            let regex = new RegExp("(-?\\d+)([DWMY])");
            let found: boolean;
            do {
                found = false;
                let match_res = input.match(regex);
                if (Helper.hasValue(match_res)) {
                    found = true;
                    this.parseComponent(match_res);
                    input = input.substr(match_res.index + match_res[0].length);
                }
            } while (found);
        }
    }

    private parseComponent(match_res: RegExpMatchArray) {
        this.countComponents++;
        if (this.countComponents > 1)
            this.viewType = 2;
        else
            this.viewType = 1;
        let count: number = parseInt(match_res[1]);
        let unitTypeDesc = match_res[2];
        let unitType: PeriodUnits;
        switch (unitTypeDesc) {
            case "D":
                unitType = PeriodUnits.Days;
                this.days = count;
                break;
            case "W":
                unitType = PeriodUnits.Weeks;
                this.weeks = count;
                break;
            case "M":
                unitType = PeriodUnits.Months;
                this.months = count;
                break;
            case "Y":
                unitType = PeriodUnits.Years;
                this.years = count;
                break;
            default:
                unitType = PeriodUnits.Months;
                this.months = count;
        }
        this.unitType = unitType;
        this.unitCount = count;
    }
}

interface NodaPeriodState {
    str: string; // gesamter string
    countComponents: number; // wie viele zeitkomponenten im string sind.
    viewType: number; // 1 - edit + typ; 2 - einzelne edits
    days?: number;
    weeks?: number;
    months?: number;
    years?: number;
    unitCount?: number;
    unitType?: PeriodUnits;
    oldStr?: string;
}


export interface NodaPeriodeNumericTextBoxProps extends BaseComponentProps {
    field: NodaPeriodeNumericTextBoxField;
    handleEval?(action: string, prepare?: any);
    value: any;
}

export interface NodaPeriodeNumericTextBoxField extends BaseField {
    showSimpleVersion?: boolean;
    defaultComboboxValue?: number;//8-Tage,4-Monate,2-Wochen,1-Jahre
}